var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Scheduler',{staticClass:"py-25 sm:px-50 max-w-xl",on:{"cancel":function($event){return _vm.$emit('close')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }